module["exports"] = [
  "NSW",
  "QLD",
  "NT",
  "SA",
  "WA",
  "TAS",
  "ACT",
  "VIC"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_AU_ocker/address/state_abbr.js
// module id = 2696
// module chunks = 1610